// /application/services-ui/alertMessages.js

export const alertMessages = {
    LOGIN_FAILED: {
      title: 'Error de inicio de sesión',
      text: 'Las credenciales no son válidas.',
      status: 'error'
    },
    LOGIN_SUCCESS: {
      title: 'Inicio de sesión exitoso',
      text: '',
      status: 'success'
    },
    NETWORK_ERROR: {
      title: 'Error de conexión',
      text: 'Hubo un problema con la conexión. Por favor, intente más tarde.',
      status: 'error'
    },
    TOKEN_NOT_FOUND: {
      title: 'Token no encontrado',
      text: 'No se encontró el token de autenticación.',
      status: 'error'
    },
    WORKSPACE_NOT_FOUND: {
      title: 'Espacio de trabajo no encontrado',
      text: 'No se encontró el espacio de trabajo.',
      status: 'error'
    },
    DEVICE_NOT_FOUND: {
      title: 'Dispositivo no encontrado',
      text: 'No se encontró el dispositivo.',
      status: 'error'
    },
    GET_DEVICES_FAILED: {
      title: 'Error al obtener dispositivos',
      text: 'No se pudieron obtener los dispositivos.',
      status: 'error'
    },
    DEVICE_NOT_CONFIGURATED: {
      title: 'Error de configuración',
      text: 'Drone no enlazado al Dock o RC',
      status: 'error'
    },
    POINT_TOO_AWAY: {
      title: 'Punto fuera de alcance',
      text: 'El punto esta fuera del alcance del drone.',
      status: 'error'
    },
    POINT_NOT_FOUND: {
      title: 'Punto no encontrado',
      text: 'No se encontró el punto.',
      status: 'error'
    },
    // Agrega aquí más alertas según sea necesario
  }
  